import { BaseApi } from '../../api/apiBase';
import type { SpeakersResponse } from '../types/speaker.types';

/**
 * API service for speaker data
 */
class SpeakersApi extends BaseApi {
  constructor() {
    super('/api/portal');
  }

  /**
   * Fetch speakers for a specific event
   * Endpoint: GET /api/portal/events/:eventSlug/speakers
   * 
   * @param eventSlug - The event slug
   * @returns Promise containing speakers and metadata
   */
  async getSpeakers(eventSlug: string): Promise<SpeakersResponse> {
    return this.getSimpleJson<SpeakersResponse>(
      `/events/${eventSlug}/speakers`
    );
  }
}

export const speakersApi = new SpeakersApi();